<template>
    <y-panel-grid :service="$services.Tagging.foldersGrid" />
</template>

<script>

    import GridPageMixin from '@/mixins/GridPage';

    export default {

        name: 'TaggingFolders',

        mixins: [GridPageMixin],

        /**
         * @inheritDoc
         */
        breadcrumbs() {
            return [
                this.$bc('dashboard', this.$t('breadcrumbs.dashboard')),
            ];
        },

    };

</script>
